import { SearchIcon } from '@/components/atoms/icons/SearchIcon';
import { TextInput } from '@/components/atoms/TextInput';
import { UI_PRIMITIVES } from '@/core/constants/uiColors';
import { useTranslation, useUIColors } from '@/core/hooks';
import { useI18nContext } from '@/core/providers/I18nProvider';
import React, { RefObject } from 'react';
import { Platform, StyleSheet } from 'react-native';

interface FAQSearchInputProps {
  value: string;
  onChangeText: (text: string) => void;
  inputRef?: RefObject<any>;
}

export function FAQSearchInput({ value, onChangeText, inputRef }: FAQSearchInputProps) {
  const colors = useUIColors();
  const { t } = useTranslation();
  const { isRTL } = useI18nContext();
  const placeholder = t('profile.faqSearchPlaceholder');

  const searchIcon = <SearchIcon size={19} color={colors.fontPrimary} />;
  const isWebRTL = Platform.OS === 'web' && isRTL;

  return (
    <TextInput
      ref={inputRef}
      placeholder={placeholder}
      value={value}
      onChangeText={onChangeText}
      variant="search"
      leftIcon={isWebRTL ? searchIcon : undefined}
      rightIcon={isWebRTL ? undefined : searchIcon}
      containerStyle={styles.searchContainer}
      inputStyle={styles.searchInput}
      placeholderTextColor={UI_PRIMITIVES.white60}
      autoCapitalize="none"
      autoCorrect={false}
      returnKeyType="search"
    />
  );
}

const styles = StyleSheet.create({
  searchContainer: {
    borderRadius: 8,
    height: 52,
  },
  searchInput: {
    flex: 1,
    color: '#333333',
  },
});
